import React from 'react';
import FormAddEditPost from '../../../components/blog/posts/FormAddEditPost';
import WrapperSection from '../../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../../components/global/GlobalBreadcrumbs';

const CreatePost = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPost />
        </WrapperSection>
    );
};

export default CreatePost;
